import { render, staticRenderFns } from "./ContentHeader.vue?vue&type=template&id=68b8843f&"
import script from "./ContentHeader.vue?vue&type=script&lang=ts&"
export * from "./ContentHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ContentHeader.vue?vue&type=style&index=0&id=68b8843f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports